import React from "react";
import "./NavBar.css";

import logo from "assets/flexi-logo.png";

function FlexiRegistrationNavbar() {
  const renderLogo = () => <img className="logo" src={logo} alt="ltl-logo" />;

  const renderNavbar = () => {
    // if already signed in, 2 cases
    // for desktop:
    if (window.matchMedia("(min-width: 800px)").matches) {
      return <>{renderLogo()}</>;
    }
    // for mobile
    return <>{renderLogo()}</>;
  };

  return renderNavbar();
}

export default FlexiRegistrationNavbar;
